import { token } from '@atlaskit/tokens';
import { AtlassianIcon } from '@atlaskit/logo';
import Avatar from '@atlaskit/avatar';
import { useUser } from '#definitions/user';
import { cssMap } from '@atlaskit/css';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import type { FunctionComponent } from 'react';

const styles = cssMap({
  avatarStyle: {
    alignSelf: 'flex-start',
    marginLeft: token('space.negative.200', '-17px'),
  },
});

const atlassianIconSizeStyle = xcss({
  width: 'space.600',
  height: 'space.600',
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const AtlassianUserIcon: FunctionComponent = () => {
  const user = useUser();
  return (
    <Inline alignInline={'center'}>
      <Box xcss={atlassianIconSizeStyle}>
        <AtlassianIcon size="xlarge" appearance={'brand'} />
      </Box>
      <Avatar
        size="small"
        src={user?.picture}
        // apply styling to put the avatar in the top-right corner
        as={({ children, ...props }) => (
          <div css={styles.avatarStyle} {...props}>
            {children}
          </div>
        )}
      />
    </Inline>
  );
};

export default AtlassianUserIcon;
